import CrossCommSession from "../CrossCommSession";
import Organization from "../Organization";
import OrganizationPlaceholder from "../OrganizationPlaceholder";
import ContentPageResponse from "./ContentPageResponse";
import ResponseBase from "./ResponseBase";

export default class SessionResponse extends ResponseBase {
    public crossCommSession!: CrossCommSession;
    public teamsToken!: string;
    public organizations!: Organization[];
    public newsfeedPage1!: ContentPageResponse;
    public notificationPage1!: ContentPageResponse;
    public selectedOrganizationId!: number;
    public organizationPlaceholders!: OrganizationPlaceholder[];
}
